export const ConfigValue = {
  PORT: process.env.PORT || 3000,
  PUBLIC_REST_API_ENDPOINT: process.env.REACT_APP_BASE_URL,
  PUBLIC_REST_API_ENDPOINT_1: process.env.REACT_APP_BASE_URL_1,
  PUBLIC_REST_API_ENDPOINT_2: process.env.REACT_APP_BASE_URL_2,
  PUBLIC_REST_API_ENDPOINT_EMAIL_TEMPLATE:
    process.env.REACT_APP_BASE_URL_EMAIL_TEMPLATE,
  PUBLIC_REST_API_ENDPOINT_ADMIN_SERVICE_V2:
    process.env.REACT_APP_BASE_URL_ADMIN_SERVICE_V2,
  PUBLIC_REST_API_ENDPOINT_PERMISSIONS_MODULE:
    process.env.REACT_APP_BASE_URL_EMAIL_TEMPLATE,
  PUBLIC_AUTH_2FA_USER_ID: process.env.REACT_APP_2FA_USER_ID,
  CAPTCHA: process.env.REACT_APP_CAPTCHA_WHITE_LABEL,
  AUTH_TOKEN_KEY: "fastoo-dashboard-auth-token",
  AUTH_USER_INFO: "fastoo-dashboard-auth-user",
  CRYPTO_SECRET_PASS: process.env.REACT_APP_SECRET_PASS,
  TOS: "https://www.google.com",
  PRIVACY_POLICY: "https://www.google.com",
  COOKIE_POLICY: "https://www.google.com",
};
